type Options = Partial<AccordionOptions>;

export interface AccordionElement extends HTMLElement {
  accordion?: Accordion;
}

export interface AccordionOptions {
  activeClass: string;
  anchorSelector: string;
  containerSelector: string;
}

export class Accordion {
  static defaults = {
    activeClass: 'is-active',
    anchorSelector: '[data-accordion-anchor]',
    containerSelector: '[data-accordion-container]',
  };

  anchors: HTMLElement[];
  element: AccordionElement;
  options: AccordionOptions;

  constructor(element: AccordionElement, options: Options) {
    if (!element || element.accordion) {
      return;
    }

    element.accordion = this;
    this.element = element;
    this.options = {
      ...Accordion.defaults,
      ...this.element.dataset,
      ...options,
    };

    const anchors = this.element.querySelectorAll(this.options.anchorSelector);

    if (!anchors) {
      return;
    }

    this.anchors = Array.from(anchors) as HTMLElement[];
    this.bind();
  }

  destroy() {
    this.element.accordion = undefined;
    this.anchors.forEach(anchor => {
      anchor.removeEventListener('click', () => this.open(anchor));
    });
  }

  toggleVisibility(element: Element) {
    element.classList.toggle(this.options.activeClass);
  }

  open(targetAnchor: HTMLElement) {
    const targetWrapper = targetAnchor.closest(this.options.containerSelector);

    if (
      targetWrapper &&
      targetWrapper.classList.contains(this.options.activeClass)
    ) {
      targetWrapper.classList.remove(this.options.activeClass);
      return;
    }

    this.anchors.forEach(anchor => {
      const wrapper = anchor.closest(this.options.containerSelector);

      if (!wrapper) {
        return;
      }

      wrapper.classList.toggle(
        this.options.activeClass,
        anchor === targetAnchor,
      );
    });
  }

  bind() {
    this.anchors.forEach(anchor => {
      anchor.addEventListener('click', () => this.open(anchor));
    });
  }
}
